import { render, staticRenderFns } from "./SpcmProduct.vue?vue&type=template&id=136980f2"
import script from "./SpcmProduct.vue?vue&type=script&lang=js"
export * from "./SpcmProduct.vue?vue&type=script&lang=js"
import style0 from "./SpcmProduct.vue?vue&type=style&index=0&id=136980f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports